export enum ListType {
    HardToMatch = 1,
    Vouchers = 2,
    PairedPatients = 3
}